import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, ElementRef } from '@angular/core';
import { AddedToCartDialogComponent, AddedToCartDialogComponentData } from '@spartacus/cart/base/components';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { RoutingService } from '@spartacus/core';
import { LaunchDialogService } from '@spartacus/storefront';
import { Subscription } from 'rxjs';
import { CartTrackingService } from 'src/app/customServices/cart-tracking.service';
import { CustomerIdService } from 'src/app/services/feature/customerId/customer-id.service';

@Component({
  selector: 'app-add-to-cartdialog',
  templateUrl: './added-to-cartdialog.component.html',
  styleUrls: ['./added-to-cartdialog.component.scss'],
  standalone: false
})
export class AddToCartDialogComponent extends AddedToCartDialogComponent {
  isMobile: boolean;
  showNetPrice$ = this.custIDService.showNetPrice$;

  productCode: string;
  quantityToSend: number;
  cartId: string;
  currentB2bUnitSendToWebtrack !: string;
  //private subscription = new Subscription
  constructor(protected override activeCartFacade: ActiveCartFacade,
    protected override launchDialogService: LaunchDialogService,
    protected override routingService: RoutingService,
    protected override el: ElementRef,
    public custIDService: CustomerIdService,
    public breakpointObserver: BreakpointObserver,
    private crtTrkService: CartTrackingService) {
    super(activeCartFacade, launchDialogService, routingService, el);
    this.subscription.add(this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small])
      .subscribe(result => {
        this.isMobile = result.matches;
      }));

    this.subscription.add(
      this.activeCartFacade.getActive().subscribe((item: any) => {
        this.cartId = item.code;
        this.currentB2bUnitSendToWebtrack = item.currentB2BUnit.uid;
      })
    );

    this.subscription.add(
      this.launchDialogService.data$.subscribe(
        (dialogData: AddedToCartDialogComponentData) => {
          this.productCode = dialogData.productCode;
          this.quantityToSend = dialogData.quantity;
        }));
    this.crtTrkService.trackAddToCart(this.productCode, this.quantityToSend, this.cartId, 'ADD _TO_CART_DIALOG', this.currentB2bUnitSendToWebtrack);
  }


}
